export default __webpack_public_path__ + "assets/img/time-left.d42822ce.svg";